import PropTypes from 'prop-types';
import useAuth from 'hooks/useAuth';
import { getRole } from 'utils/common';

const RoleGuard = ({ minRole = 10, children }) => {
  useAuth(minRole);

  if (getRole() < minRole) {
    return null;
  }

  return children;
};

RoleGuard.propTypes = {
  minRole: PropTypes.number,
  children: PropTypes.node
};

export default RoleGuard;
